import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { useTranslation } from "react-i18next";
import classes from "./Activities.module.css";
import styles from "./activityCards.module.css";
import { testUrl } from "../BaseData";
import Pagination from "@mui/material/Pagination";
import ActivityFiles from "./ActivityFiles";

const XalqaroAloqalar = () => {
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [category, setCategory] = useState(null);
  const [activityTypes, setActivityTypes] = useState([]);
  const [news, setNews] = useState([]);
  const [departmentActivities, setDepartmentActivities] = useState([]);
  const [files, setFiles] = useState([]);
  const [pageApi, setPageApi] = useState(1);
  const itemsPerPage = 9;

  // Function to sort sidebar items to match navbar order
  const sortSidebarItems = (items) => {
    const navbarOrder = [
      'xalqaro-aloqalar',
      'xalqaro-etirof',
      'xorijda-talim',
      'hamkorlarimiz'
    ];

    return items.sort((a, b) => {
      const aIndex = navbarOrder.indexOf(a.short_name);
      const bIndex = navbarOrder.indexOf(b.short_name);

      // If both items are in the navbar order, sort by their position
      if (aIndex !== -1 && bIndex !== -1) {
        return aIndex - bIndex;
      }

      // If only one item is in the navbar order, prioritize it
      if (aIndex !== -1) return -1;
      if (bIndex !== -1) return 1;

      // If neither item is in the navbar order, keep original order
      return 0;
    });
  };

  useEffect(() => {
    setLoading(true);
    setError(null);

    const fetchData = axios.get(testUrl + "/api/baseactivity/hamkorlik/xalqaro-aloqalar");

    Promise.all([fetchData])
      .then(([response]) => {
        const data = response.data;
        if (data) {
          setCategory(data.category || null);
          const sortedItems = sortSidebarItems(data.activities_types || []);
          setActivityTypes(sortedItems);
          setNews(data.activities_post || []);
          setDepartmentActivities(data.department_activities || []);
          setFiles(data.files || []);
        }
      })
      .catch(() => setError("Ma'lumotlarni yuklashda xatolik"))
      .finally(() => setLoading(false));
  }, [i18n.language]);

  const indexOfLastItem = pageApi * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentNews = news.slice(indexOfFirstItem, indexOfLastItem);

  if (loading) return <div>Yuklanmoqda...</div>;
  if (error) return <div>{error}</div>;

  const currentShort = "xalqaro-aloqalar";

  return (
    <div className={classes["mainContainer"]}>
      <div data-aos="fade-up" className={classes["container"]}>
        <h1 className={classes["page-title"]}>{t("Xalqaro aloqalar")}</h1>
        <div className={styles.facultyGrid}>
          {currentNews.map((item) => (
            <div
              key={`${item.source || "activity"}-${item.id}`}
              className={styles.activityCard}
              onClick={() =>
                navigate(
                  item.source === "news"
                    ? `/news/${item.id}`
                    : `/activity/${item.id}`
                )
              }
            >
              <img src={item.image} alt=" " className={styles.activityImage} />
              <div className={styles.activityInfo}>
                <h3>{item[`name_${i18n.language}`] || item.name_uz}</h3>
              </div>
            </div>
          ))}
        </div>
        <ActivityFiles
          files={files}
          title={{ uz: "Memorandumlar", en: "Memorandums", ru: "Меморандумы" }}
        />
        {departmentActivities.length > 0 && (
          <div className={classes["department-contributions"]}>
            <h2 className={classes["section-title"]}>{t("Kafedralar kesimida")}</h2>
            <div className={styles.facultyList}>
              {departmentActivities.map((item) => (
                <div
                  key={item.id}
                  className={styles.facultyCard}
                  onClick={() => navigate(`/activities/${item.department.short_name}/${item.category.short_name}/`)}
                >
                  <div className={styles.facultyInfo}>
                    <h3>{item.department[`name_${i18n.language}`]}</h3>
                    <p>{t("Batafsil ko'rish")}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
      <div className={classes.sidebar}>
        <h3>
          {category ? category[`name_${i18n.language}`] : "Error page"}
        </h3>
        <ul>
          {activityTypes.map((cat) => (
            <li
              key={cat.id}
              className={cat.short_name === currentShort ? classes.active : ''}
              onClick={() => navigate(`/activity/hamkorlik/${cat.short_name}`)}
            >
              {cat[`name_${i18n.language}`]}
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default XalqaroAloqalar; 